import styled, { css } from 'styled-components';
import { LayoutBox } from 'src/common/components/LayoutBox';
import { media } from 'src/config/breakpoints';

export const UserProfileLayoutBox = styled(LayoutBox)`
  ${media.w.between.px992.px1200(css`
    margin-right: 0;
  `)};
`;
